<template>
	<div>
		<!-- Search Backdrop (Blur effect) -->
		<div
			v-if="searchActive"
			class="search-backdrop"
			@click="closeSearchDropdown"
		></div>

		<!-- ─── Main Header ─────────────────────────────────── -->
		<header
			class="new-header"
			:class="{
				'header-hidden-mobile': showResumeClinic && !loginModalOpen,
				'header-over-modal': showResumeClinic && loginModalOpen,
				'search-active-header': searchActive,
			}"
		>
			<div class="header-main2">
				<div class="head-div d-flex gap-3">
					<img
						id="hideinlaptop"
						@click="openMobileMenu()"
						src="../../assets/guestHeader/hamburger.svg"
						alt="Menu"
					/>
					<img
						class="logo pointer"
						@click="goToHire3xHome()"
						src="https://d33yrtc8qntbdn.cloudfront.net/Hire3xAssests/Website/Header/hire3x-logo.svg"
						alt="Hire3x Logo"
					/>
				</div>
				<div
					:class="{
						'extra-div': searchActive,
						extraheight: searchActive && !isLaptop,
					}"
				></div>
				<!-- <div id="hideinmobile" class="color-4A7EFF fam-inter fw-500 fs-16">
				Find Mentor
			</div> -->

				<!-- Expanded Search Container -->
				<div class="header-center-area lap-pl-5">
					<!-- Tabs -->
					<div
						class="search-tabs-container opacity-0"
						:class="{ 'is-active': searchActive, foriswebmobile: isWeb() }"
					>
						<div
							class="search-tab"
							@click="selectTab('job')"
							:class="{ active: selectedTab === 'job' }"
						>
							Jobs
						</div>
						<span class="divider">|</span>
						<div
							class="search-tab"
							@click="selectTab('assessment')"
							:class="{ active: selectedTab === 'assessment' }"
						>
							Assessments
						</div>
						<span class="divider">|</span>
						<div
							class="search-tab"
							@click="selectTab('course')"
							:class="{ active: selectedTab === 'course' }"
						>
							Courses
						</div>
					</div>

					<!-- Search Bar -->
					<div
						class="search-bar-wrapper"
						:class="{ 'is-active': searchActive }"
					>
						<div class="d-flex gap-2 w-100">
							<img
								id="hideinlaptop"
								@click="closeSearchDropdown"
								class="shadow"
								src="../../assets/guestHeader/search-back.svg"
								alt="Close Search"
							/>
							<div class="d-flex w-100 justify-content-center">
								<div class="header-search">
									<b-form-input
										ref="headerSearchInput"
										:key="searchInputName"
										type="text"
										name="global-search"
										placeholder="Search.."
										:readonly="searchInputReadOnly"
										@focus="handleSearchFocus"
										@click="handleSearchFocus"
										v-model="searchQuery"
										@input="onSearchInput"
										@keydown.enter.native.prevent="
											performSearch(getLiveSearchQuery())
										"
										autocomplete="off"
										autocapitalize="off"
										autocorrect="off"
										spellcheck="false"
									></b-form-input>
									<img
										src="../../assets/guestHeader/darksearchicon.svg"
										alt="Search Icon"
										class="pointer"
										@click="performSearch(getLiveSearchQuery())"
									/>
								</div>
							</div>
						</div>

						<!-- Search Dropdown Content Component -->
						<SearchDropdown
							v-show="searchActive"
							:isVisible="searchActive"
							:selectedTab="selectedTab"
							:headerSearchQuery="searchQuery"
							:headerSearchSuggestion="searchSuggestion"
							:isSearching="isSearchLoading"
							@close-modal="closeSearchDropdown"
							@open-login-modal="openLoginModal"
							@openResumeClinic="handleOpenResumeClinic"
							@reset-search="resetSearchState"
							@click-history="handleHistorySelection"
						/>
					</div>
				</div>

				<!-- Overlay to close search dropdown -->
				<div
					class="search-overlay"
					v-if="searchActive"
					@click="closeSearchDropdown"
				></div>

				<!-- Mobile: search icon -->
				<div id="hideinlaptop" class="d-flex align-items-center">
					<div @click="openMobileSearch()">
						<img src="../../assets/guestHeader/search.svg" alt="Search" />
					</div>
				</div>

				<!-- Desktop action buttons -->
				<div
					id="hideinmobile"
					class="header-btns d-flex gap-16px align-items-center"
				>
					<!-- Notification bell (desktop only) -->
					<div class="pointer" @click="openNotificationPanel()">
						<img src="../../assets/img/guesheader-noti.svg" alt="" />
					</div>
					<b-button @click="goToHire3xAdminHome()" class="header-for-biz-btn">
						<img
							src="../../assets/guestHeader/forBusiness.svg"
							alt="For Business Icon"
						/>
						For Business
					</b-button>
					<b-button @click="openLoginModal" class="candash-addBtn padding813px"
						>Login <img src="../../assets/img/loginArrow.svg" alt="Login Arrow"
					/></b-button>
				</div>
			</div>
		</header>

		<!-- ─── Notification Slide Panel ──────────────────────── -->
		<transition name="notif-slide">
			<div v-if="notifOpen" class="notif-panel">
				<div class="notif-panel-header">
					<span class="notif-panel-title">Notifications</span>
					<button class="notif-close-btn" @click="notifOpen = false">✕</button>
				</div>

				<div class="notif-list">
					<div v-for="(notif, i) in notifications" :key="i" class="notif-card">
						<div
							class="notif-card-body pointer"
							@click="handleNotifAction(notif)"
						>
							<img class="notif-avatar" :src="notif.avatar" :alt="notif.name" />
							<div class="notif-text">
								<p class="notif-name">{{ notif.name }}</p>
								<p class="notif-msg">{{ notif.message }}</p>
								<button
									v-if="notif.cta"
									class="notif-cta"
									@click.stop="handleNotifAction(notif)"
								>
									{{ notif.cta }}
								</button>
							</div>
						</div>
					</div>

					<div v-if="notifications.length === 0" class="notif-empty">
						You're all caught up! 🎉
					</div>
				</div>
			</div>
		</transition>

		<!-- Overlay to close notification panel -->
		<div
			v-if="notifOpen"
			class="notif-overlay"
			@click="notifOpen = false"
		></div>

		<!-- ─── Mobile Menu Drawer ──────────────────────── -->
		<transition name="slide-left">
			<div v-if="isMobileMenuOpen" class="mobile-drawer-menu">
				<div class="drawer-header">
					<div class="d-flex align-items-center gap-2">
						<img
							@click="goToHire3xHome()"
							class="logo"
							src="https://d33yrtc8qntbdn.cloudfront.net/Hire3xAssests/Website/Header/hire3x-logo.svg"
							alt="Hire3x Logo"
						/>
					</div>
					<button class="drawer-close" @click="isMobileMenuOpen = false">
						✕
					</button>
				</div>

				<div class="drawer-scroll-area">
					<nav class="drawer-nav">
						<div
							class="drawer-link"
							@click="handleDrawerClick({ name: 'Interviews' })"
						>
							<div class="drawer-icon-placeholder">
								<img
									src="../../assets/guestHeader/s-mock-interview.svg"
									alt="Mock Interviews Icon"
								/>
							</div>
							Mock Interviews
						</div>
						<div
							class="drawer-link"
							@click="handleDrawerClick({ name: 'Fix Resume' })"
						>
							<div class="drawer-icon-placeholder">
								<img
									src="../../assets/guestHeader/s-resume-clinic.svg"
									alt="Resume Clinic Icon"
								/>
							</div>
							Resume Clinic
						</div>
						<div
							class="drawer-link"
							@click="handleDrawerClick({ name: 'Assessment' })"
						>
							<div class="drawer-icon-placeholder">
								<img
									src="../../assets/guestHeader/s-mock-assess.svg"
									alt="Mock Assessments Icon"
								/>
							</div>
							Mock Assessments
						</div>
						<div
							class="drawer-link"
							@click="handleDrawerClick({ name: 'Jobs' })"
						>
							<div class="drawer-icon-placeholder">
								<img
									src="../../assets/guestHeader/s-find-job.svg"
									alt="Find Jobs Icon"
								/>
							</div>
							Find Jobs
						</div>
						<div
							class="drawer-link"
							@click="handleDrawerClick({ name: 'Courses' })"
						>
							<div class="drawer-icon-placeholder">
								<img
									src="../../assets/guestHeader/s-find-course.svg"
									alt="Find Courses Icon"
								/>
							</div>
							Find Courses
						</div>
						<!-- <div
							class="drawer-link"
							@click="handleDrawerClick({ name: 'Mentor' })"
						>
							<div class="drawer-icon-placeholder">
								<img
									src="../../assets/guestHeader/s-find-mentor.svg"
									alt="Find Mentors Icon"
								/>
							</div>
							Find Mentors
						</div> -->
					</nav>

					<div class="drawer-divider"></div>

					<nav class="drawer-nav">
						<div class="drawer-link" @click="TriggereRegisterModal()">
							<div class="drawer-icon-placeholder">
								<img
									src="../../assets/guestHeader/s-register.svg"
									alt="Register Icon"
								/>
							</div>
							Register- As a Candidate
						</div>
						<div class="drawer-link" @click="goToReuqest()">
							<div class="drawer-icon-placeholder">
								<img
									src="../../assets/guestHeader/s-business.svg"
									alt="Business Icon"
								/>
							</div>
							Business- Request a Demo
						</div>
						<div class="drawer-link" @click="goToPlaystore()">
							<div class="drawer-icon-placeholder">
								<img
									src="../../assets/guestHeader/s-get-app.svg"
									alt="Get App Icon"
								/>
							</div>
							Get our App
						</div>
					</nav>
				</div>

				<footer class="drawer-footer">
					<div @click="goToHire3xAdminHome()" class="drawer-banner mb-4">
						<div class="w-100">
							<img
								class="w-100"
								src="../../assets/guestHeader/s-banner.svg"
								alt="App Promotional Banner"
							/>
						</div>
					</div>
					<!-- <button class="main-blue-btn w-100">Log out</button> -->
					<button
						class="main-blue-btn w-100"
						@click="(isMobileMenuOpen = false), openLoginModal()"
					>
						Log in
					</button>
				</footer>
			</div>
		</transition>

		<div
			v-if="isMobileMenuOpen"
			class="drawer-overlay"
			@click="isMobileMenuOpen = false"
		></div>
		<!-- Resume Clinic Modal -->
		<ResumeClinic
			v-if="showResumeClinic"
			:showModal="showResumeClinic"
			:customClass="'guestHeader'"
			@openLoginModal="openLoginModalWithUUID"
			@openLoginModalWithJobID="openLoginModalWithJobID"
			@modalClose="showResumeClinic = false"
		/>
	</div>
</template>

<script>
import SearchDropdown from "./SearchDropdown.vue";
import EventBus from "@/utils/EventBus";
import { config } from "@/config";
import { hasAccess } from "@/utils/tokenCheck";
import ResumeClinic from "../BuilderPage/ResumeclinicModal.vue";
import globalSearchMixin from "@/components/mixin/globalSearchMixin";
import { openLoginModal } from "@/utils/tokenCheck";
import "../../assets/globalcss/headerpage.css";
import { isWeb } from "@/utils/platform.js";
import heeraNotificationMixin from "@/components/mixin/heeraNotificationMixin";

export default {
	mixins: [globalSearchMixin, heeraNotificationMixin],
	components: {
		SearchDropdown,
		ResumeClinic,
	},
	data() {
		return {
			isMobileMenuOpen: false,
			searchActive: false,
			isClosingSearchDropdown: false,
			searchInputReadOnly: true,
			searchInputName: "global-search",
			showResumeClinic: false,
			loginModalOpen: false,
			selectedTab: "job",
			searchQuery: "",
			isLaptop: true,
		};
	},
	computed: {
		isLoggedIn() {
			return localStorage.getItem("vue_token") ? true : false;
		},
	},
	watch: {
		$route() {
			if (this.searchActive) {
				this.closeSearchDropdown();
			}
		},
		searchActive(val) {
			if (val) {
				this.selectedTab = "job";
			}
			if (val || this.notifOpen || this.isMobileMenuOpen) {
				document.body.style.overflow = "hidden";
			} else {
				document.body.style.overflow = "";
			}
			EventBus.$emit("header-search-state", val);
		},
		isMobileMenuOpen(val) {
			if (val || this.searchActive || this.notifOpen) {
				document.body.style.overflow = "hidden";
			} else {
				document.body.style.overflow = "";
			}

			EventBus.$emit("mobile-menu-state", val);
		},
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.checkScreenSize);
		document.removeEventListener("mousedown", this.handleDocumentClick, true);
		document.body.style.overflow = "";
		EventBus.$off("open-login-modal", this.onLoginModalOpened);
		EventBus.$off("close-login-modal", this.onLoginModalClosed);
		EventBus.$off("close-resume-clinic", this.onCloseResumeClinic);
		EventBus.$off("close-mobile-menu", this.onCloseMobileMenu);
		EventBus.$off("close-header-search", this.onCloseHeaderSearch);
		window.removeEventListener("focus", this.onWindowFocus);
	},
	created() {
		this.selectedTab = "job";
		this.getSearchSuggestionsData(this.searchQuery, this.selectedTab);
		this.loadNotifications();
	},
	mounted() {
		window.addEventListener("resize", this.checkScreenSize);
		this.checkScreenSize();
		document.addEventListener("mousedown", this.handleDocumentClick, true);
		this.onCloseResumeClinic = () => {
			this.showResumeClinic = false;
		};
		this.onLoginModalOpened = () => {
			this.loginModalOpen = true;
		};
		this.onLoginModalClosed = () => {
			this.loginModalOpen = false;
		};
		this.onCloseHeaderSearch = () => {
			this.closeSearchDropdown();
		};
		this.onCloseMobileMenu = () => {
			this.isMobileMenuOpen = false;
		};
		EventBus.$on("open-login-modal", this.onLoginModalOpened);
		EventBus.$on("close-login-modal", this.onLoginModalClosed);
		EventBus.$on("close-mobile-menu", this.onCloseMobileMenu);
		EventBus.$on("close-header-search", this.onCloseHeaderSearch);
		EventBus.$on("close-resume-clinic", this.onCloseResumeClinic);
		this.onWindowFocus = () => {
			this.loadNotifications();
		};
		window.addEventListener("focus", this.onWindowFocus);
	},
	methods: {
		isWeb,
		checkScreenSize() {
			this.isLaptop = window.innerWidth >= 1024;
		},
		openNotificationPanel() {
			if (this.searchActive) {
				this.closeSearchDropdown();
			}
			this.notifOpen = true;
		},
		getLiveSearchQuery() {
			const inputRef = this.$refs.headerSearchInput;
			if (!inputRef) return (this.searchQuery || "").toString();

			const rootEl = inputRef.$el || inputRef;
			if (rootEl && typeof rootEl.value === "string") {
				return rootEl.value;
			}

			const nestedInput =
				rootEl && rootEl.querySelector ? rootEl.querySelector("input") : null;
			return nestedInput && typeof nestedInput.value === "string"
				? nestedInput.value
				: (this.searchQuery || "").toString();
		},
		handleDocumentClick(event) {
			if (!this.searchActive) return;
			if (
				!event.target.closest(".search-bar-wrapper, .search-tabs-container")
			) {
				this.closeSearchDropdown();
			}
		},
		//this clears everything for inner-searchbar when guestheader searchbar is clicked.
		handleSearchFocus() {
			if (this.isClosingSearchDropdown) return;

			this.searchInputReadOnly = false;
			const isOpeningFresh = !this.searchActive;
			this.searchActive = true;

			if (isOpeningFresh) {
				this.selectedTab = "job";
				this.searchQuery = "";
				this.searchSuggestion = [];
				EventBus.$emit("clear-inner-search");
			}
		},
		handleHistorySelection(query) {
			this.searchQuery = query;
			this.performSearch(query);
		},
		performSearch(forcedQuery = null) {
			const query = (
				forcedQuery ??
				this.getLiveSearchQuery() ??
				this.searchQuery
			)
				.toString()
				.trim();
			const type = this.selectedTab;
			if (!query) return;

			this.searchQuery = query;
			this.closeSearchDropdown();
			this.handleEnterSearch(query, type);
		},
		resetSearchState() {
			this.searchQuery = "";
			this.selectedTab = "job";
		},
		goToPlaystore() {
			window.location.href =
				"https://play.google.com/store/apps/details?id=com.hire3x.candidate";
		},
		goToReuqest() {
			window.location.href = `${this.config.websiteBase}requestdemo`;
		},
		TriggereRegisterModal() {
			if (this.isMobileMenuOpen) {
				this.isMobileMenuOpen = false;
			}
			openLoginModal({ mode: "register" });
		},
		openMobileSearch() {
			if (this.notifOpen) {
				this.notifOpen = false;
			}

			const loginModal = document.getElementById("loginModal");
			const isLoginModalOpen =
				loginModal &&
				loginModal.classList.contains("show") &&
				loginModal.getAttribute("aria-hidden") !== "true";

			if (isLoginModalOpen) {
				EventBus.$emit("close-login-modal");

				// Wait for modal route pop/replace to finish before activating search
				setTimeout(() => {
					this.searchActive = true;
				}, 100);
				return;
			}

			this.searchActive = true;
		},
		openMobileMenu() {
			if (this.isMobileMenuOpen) {
				this.isMobileMenuOpen = false;
				return;
			}

			if (this.notifOpen) {
				this.notifOpen = false;
			}

			const loginModal = document.getElementById("loginModal");
			const isLoginModalOpen =
				loginModal &&
				loginModal.classList.contains("show") &&
				loginModal.getAttribute("aria-hidden") !== "true";

			if (isLoginModalOpen) {
				EventBus.$emit("close-login-modal");
			}
			this.isMobileMenuOpen = true;
		},
		goToHire3xHome() {
			window.location.href = `${this.config.websiteBase}`;
		},
		goToHire3xAdminHome() {
			window.location.href = `${this.config.websiteBase}home`;
		},
		openLoginModalWithUUID(uuid) {
			this.$store.commit("userVUEX/SET_RESUME_UUID", uuid);
			this.$store.commit("userVUEX/setresumeJobid", null);
			this.openingLoginModal();
		},
		openLoginModalWithJobID(jobId, uuid) {
			this.$store.commit("userVUEX/SET_RESUME_UUID", uuid);
			this.$store.commit("userVUEX/setresumeJobid", jobId);
			this.openingLoginModal();
		},

		openingLoginModal() {
			EventBus.$emit("open-login-modal");
		},

		handleOpenResumeClinic() {
			this.showResumeClinic = true;
			this.searchActive = false;
		},
		openLoginModal() {
			if (this.searchActive) {
				this.closeSearchDropdown();
			}
			openLoginModal();
		},
		hasAccess() {
			return hasAccess();
		},
		goToCourseDetail(tag) {
			this.closeSearchDropdown();
			const courseName = tag.title || tag.courseName || tag.name;
			const courseId = tag.courseID || tag.referenceID;
			if (!courseId) return;

			// Track search interaction before redirecting
			this.trackSearchInteraction(courseName, "courses");

			const encodedCourseName = encodeURIComponent(courseName || "");
			const link = `${this.config.trainingBase}/coursedetail/${courseId}?courseName=${encodedCourseName}`;
			window.open(link, "_self");
		},
		handleExploreClick(item) {
			const isGuest = !this.hasAccess();
			if (isGuest) {
				this.handleLoggedOutExploreClick(item);
				return;
			}
			this.$emit("close-modal");
			switch (item.name) {
				case "Resume":
					this.$router.push({ name: "Dashboard" });
					break;
				case "Interviews":
					this.$router.push({ name: "PrepareInterview" });
					break;
				case "Jobs":
					this.$router.push({ name: "JobSearch" });
					break;
				case "Courses":
					window.location.href = `${this.config.trainingBase}/filteredcoursesview`;
					break;
				case "Roadmap":
					this.$router.push({ name: "PrepareInterview" });
					break;
				case "Assessment":
					this.$router.push({ name: "Assessment" });
					break;
				case "Fix Resume":
					this.handleOpenResumeClinic();
					break;
				case "Mentor":
					this.$router.push({ name: "Assessment" });
					break;
			}
		},
		handleLoggedOutExploreClick(item) {
			switch (item.name) {
				case "Resume":
					this.$emit("close-modal");
					openLoginModal({
						redirectUrl: `${this.config.candidateBase}/dashboard/?from=candidate`,
					});
					break;
				case "Interviews":
					this.$emit("close-modal");
					window.location.href = `${this.config.websiteBase}#mockinterviews`;
					break;
				case "Jobs":
					this.$emit("close-modal");
					window.location.href = `${this.config.websiteBase}#jobs`;
					break;
				case "Courses":
					this.$emit("close-modal");
					window.location.href = `${this.config.websiteBase}#courses`;
					break;
				case "Roadmap":
					this.$emit("close-modal");
					window.location.href = `${this.config.websiteBase}#mockinterviews`;
					break;
				case "Assessment":
					this.$emit("close-modal");
					window.location.href = `${this.config.websiteBase}#assessments`;
					break;
				case "Fix Resume":
					this.handleOpenResumeClinic();
					break;
				case "Mentor":
					this.$router.push({ name: "Assessment" });
					break;
			}
		},

		selectTab(data) {
			this.selectedTab = data;
			this.searchQuery = "";
		},
		onSearchInput(value) {
			const query = (value ?? "").toString();
			this.searchQuery = query;

			if (query) {
				this.getSearchSuggestionsData(query, this.selectedTab);
			} else {
				this.searchSuggestion = [];
				this.isSearchLoading = false;
			}
		},
		closeSearchDropdown() {
			this.isClosingSearchDropdown = true;
			this.searchActive = false;
			this.searchInputReadOnly = true;
			this.searchInputName = "global-search";
			this.searchQuery = "";
			this.selectedTab = "job";
			this.searchSuggestion = [];
			// Blur the input to ensure the next click triggers a focus event
			if (this.$refs.headerSearchInput) {
				const rootEl =
					this.$refs.headerSearchInput.$el || this.$refs.headerSearchInput;
				const inputEl =
					rootEl && rootEl.tagName === "INPUT"
						? rootEl
						: rootEl && rootEl.querySelector
						? rootEl.querySelector("input")
						: null;
				if (inputEl && inputEl.blur) inputEl.blur();
			}

			this.$nextTick(() => {
				setTimeout(() => {
					this.isClosingSearchDropdown = false;
				}, 0);
			});
		},
		handleDrawerClick(item) {
			this.handleExploreClick(item);
			this.isMobileMenuOpen = false;
		},
	},
};
</script>

<style scoped>
.extraheight {
	height: 100vh;
}
.padding813px {
	width: 125px;
	font-family: "Inter", sans-serif;
	font-weight: 600 !important;
	font-size: 16px !important;
	color: #ffffff !important;
	height: 40px;
	padding: 8px 24px !important;
	justify-content: center;
}
.gap-16px {
	gap: 16px;
}
</style>
